module.exports = __webpack_public_path__ + "img/Radausflug.1c677fd0.jpg";